import {
    ChangeDetectionStrategy,
    Component,
} from '@angular/core';
import {
    IEnvironment,
    ModalResultType,
} from '@models';
import {
    GRID_SERVICE,
    ODataGridComponent,
    STATE_HANDLER,
    urlStateHandler,
} from '@pages/generics/grid';
import { EnvironmentService } from '@services';

import cloneDeep from 'lodash-es/cloneDeep';
import { take } from 'rxjs/operators';

import {
    EnvironmentModalComponent,
    EnvironmentRobotsModalComponent,
} from './modals';

@Component({
    templateUrl: './environments.page.html',
    providers: [{
        provide: GRID_SERVICE,
        useClass: EnvironmentService,
    },
    {
        provide: STATE_HANDLER,
        useValue: urlStateHandler,
    }],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EnvironmentsPageComponent extends ODataGridComponent<IEnvironment, number> {
    public openModal(model?: IEnvironment) {
        let clone: IEnvironment | undefined;
        if (model) {
            clone = cloneDeep(model);
        }

        this._modal
            .openModal(EnvironmentModalComponent, clone)
            .afterClosedResult()
            .subscribe(res => {
                switch (res.type) {
                    case ModalResultType.Add:
                        this._openEnvironmentModal(res.data!);
                        break;
                    case ModalResultType.Update:
                        this._refresh$.next();
                        break;
                }
            });
    }

    public showEnvironment(entry: IEnvironment) {
        this._modal.openModal(EnvironmentRobotsModalComponent, cloneDeep(entry), {
            autoFocus: false,
        });
    }

    private _openEnvironmentModal = (data: IEnvironment) => {
        this._grid.dataManager
            .data$
            .pipe(take(1))
            .subscribe(() => {
                this._refresh$.next();
                this.showEnvironment(data);
            });
    }
}
